// extracted by mini-css-extract-plugin
module.exports = {"container":"CardV2_container__2X_db","informative":"CardV2_informative__3zYF3","divisor":"CardV2_divisor__1fsfl"};